import React from 'react';
import IconButton from '@material-ui/core/IconButton';
import {cl,globs} from '../../components/utils/utils';

class C18MuiInput extends React.Component{
  constructor(props) {
    super(props);
//     cl(props)
    this.state={
    }
  }
  
  render(){
    if(globs.noMui){
      return(
        <div>
          {this.props.children}
        </div>
      )
    }else{
      return React.createElement(IconButton,this.props)
    }
  }
}
      
export default C18MuiInput;
 
